import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DatasearchService {
  readonly ApiUrl: string = environment.appUrl;

  constructor(private http: HttpClient) { }

  //user login

  getLoginUser(postdata: any) {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user/auth-login`, postdata);
  }

  // Get awards
  getAwards() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/awards/`);
  }

  // Get advisory
  getAdvisory() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/advisory-panels/`);
  }

  // Get events
  getEvents() {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/events`, {});
  }

  // Get Clients
  getClients(pageNumber: number = 1, rows: number = 100) {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/clients?pageNumber=${pageNumber}&rows=${rows}`);
  }

  // Get Clients For Home
  getClients_home() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/clients/`);
  }
  // Get patent-services
  getPatents() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/patent-services/all`);
  }
  // Get event details
  getEventDetails(id: number) {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/events/${id}`);
  }

  // Get gallery
  getGallary() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/galleries/`);
  }

  // Get gallery details
  getGallaryDetails(id: string) {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/galleries/${id}`);
  }

  // Get Our Story
  getOurStory() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/stories/`);
  }
  // Get Our Story
  getPartners() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/partners/`);
  }

  // Get press releases
  getPressReleases() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/press-releases/`);
  }

  // Get press release details
  getPressReleasesDetails(id: string) {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/press-releases/${id}`);
  }

  // Get team members
  getAllHeadings() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/heading-subheading/`);
  }

  // Get team members
  getTeamMembers() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/team-members/`);
  }

  // // Get training videos
  getTrainingvideos() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/trainings/`);
  }

  // Get user profession
  getUserprofession() {
    return this.http.get<any>('https://www.chemrobotics.com/staging/UserLoginController/get_scientific_professions');
  }
  getPdfs() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/pdfs/`);
  }

  // Get user profile
  getUserprofile(postdata: any) {
    return this.http.post<any>('https://www.chemrobotics.com/staging/UserLoginController/get_user_data', postdata);
  }
  // Post career forms
  postCareerAtforms(formData: FormData) {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/submit-job-application`, formData);
  }

  postFileUpdate(postdata: any) {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/uploadfile`, postdata);
  }
  postFileUpdate_careerat(postdata: any) {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/uploadfile-careerat`, postdata);
  }

  // Post career jobs
  getCareerAtjobs() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/jobs/`);
  }
  // get Regulatory service
  getRegulatoryservice() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/regulatory-services`);
  }
  // Send change password request
  sendChngepswd(postdata: any) {
    return this.http.post<any>('https://www.chemrobotics.com/staging/UserLoginController/change_user_password', postdata);
  }

  // Send change password request
  sendResetpswd(formData: FormData) {
    return this.http.post<any>('https://www.chemrobotics.com/staging//UserLoginController/reset_password', formData);
  }

  // Send change password request
  sendForgotpswd(formData: FormData) {
    return this.http.post<any>('https://www.chemrobotics.com/staging//UserLoginController/forgot_password', formData);
  }

  // Send contact us request
  sendInquiryForm(postdata: any) {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/user-queries/saveUserQuery`, postdata);
  }
  // Send demo request
  sendDemorequest(postdata: any) {
    return this.http.post<any>(`${this.ApiUrl}/api/v2/demo-request`, postdata);
  }

  // Send signup request
  sendSignup(formData: FormData) {
    return this.http.post<any>('https://www.chemrobotics.com/staging/UserLoginController/register_new_user', formData);
    // return 1
  }

  // Send update request
  sendUpdate(postdata: any) {
    return this.http.post<any>('https://www.chemrobotics.com/staging/UserLoginController/update_user_data', postdata);
  }
  // Post career jobs
  getFooter() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/layout/footer`);
  }
  // Post career jobs
  getHeader() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/layout/header`);
  }
  // Post career jobs
  getEthics() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/ethics`);
  }
  // get about us
  getAboutus() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/about-us/`);
  }
  // get about us
  getBrochure() {
    return this.http.get<any>(`${this.ApiUrl}/api/v2/brochures/`);
  }
  // Get training by database
  findTrainingByDatabase(postdata: any) {
    return this.http.post<any>(
      `${this.ApiUrl}/api/v2/find-training-by-database`,
      postdata
    );
  }

}
